import myzod, { Infer } from 'myzod'

export enum CustomerReviewEventActionEnum {
  Created = 'Created',
  Modified = 'Modified',
}

const ratingSchema = myzod.object({
  comment: myzod.string().optional(),
  rating: myzod.number().min(1).max(5).optional(),
})

export const customerReviewEventSchema = myzod.object({
  action: myzod.enum(CustomerReviewEventActionEnum),
  pk: myzod.string().pattern(/^User#/),
  sk: myzod.string().pattern(/^CustomerReview#-#Job#/),
  New: ratingSchema,
  Original: ratingSchema.optional(),
})

export type CustomerReviewEvent = Infer<typeof customerReviewEventSchema>
